// extracted by mini-css-extract-plugin
export default {"yellowStar":"Rating_yellowStar__VyvjI","greyStar":"Rating_greyStar__4R4HY"};